import { notification } from 'antd';
import type { LoaderFunctionArgs } from 'react-router';
import { redirect } from 'react-router';

import type { createStore } from '../../../store';
import store from '../../../store';
import { checkToken, updateTokenFromPath } from './resetPasswordSlice';

export const resetPasswordLoaderWithStore = (createdStore: ReturnType<typeof createStore> = store) => {
  const resetPasswordLoader = async ({ params }: LoaderFunctionArgs) => {
    if (params.token) {
      createdStore.dispatch(updateTokenFromPath(params.token));
      const response = await createdStore.dispatch(checkToken());

      if (checkToken.fulfilled.match(response) && response.payload === false) {
        notification.error({
          title: 'Token expired',
          description: 'Your link is expired. Please request a new password reset email.',
        });
        return redirect('/login');
      } else if (checkToken.rejected.match(response)) {
        notification.error({
          title: 'Error',
          description: 'Invalid token. Please request a new password reset email.',
        });
        return redirect('/forgot-password');
      }
    }
    return null;
  };

  return resetPasswordLoader;
};
